module.exports = __webpack_public_path__ + "media/images/icons/filled/question-circle-2c1229ffade429ce49c080ecb2bf0bd5.svg";